const components = new Map()

components.set('media.logo', ctx => ({
  component: 'MediaComponent',
  key: 'media.logo',
  defaultPlacement: 'presentation',
  props: {
    label: ctx.labels['logo'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    enableDescription: false,
    enableAlt: false,
  },
}))

components.set('media.logoInverted', ctx => ({
  key: 'media.logoInverted',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels['logoInverted'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    enableDescription: false,
    enableAlt: false,
  },
}))

components.set('media.favicon', ctx => ({
  key: 'media.favicon',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.favicon,
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: { maxWidth: 200 } },
    enableDescription: false,
    enableAlt: false,
  },
}))

components.set('themeColor', ctx => ({
  key: 'theme.primary',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('primaryColor'),
    'data-field': 'themeColor',
  },
}))

components.set('themeColorSecondary', ctx => ({
  key: 'theme.secondary',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('secondaryColor'),
    'data-field': 'themeColorSecondary',
  },
}))

components.set('theme.template', ctx => ({
  key: 'theme.template',
  defaultPlacement: 'theme',
  component: 'ThemeSelector',
  props: {
    data: ctx.data,
    'data-field': 'theme-template',
  },
}))

components.set('publishing', ctx => ({
  key: 'publishing',
  defaultPlacement: 'publishing',
  component: 'Publishing',
  props: {
    data: ctx.data,
  },
}))

export default components
